import { library } from '@fortawesome/fontawesome-svg-core'
import { faImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'

import styles from './index.module.css'

// ----------------------------------------------------------------------------

library.add(faImage)

// ----------------------------------------------------------------------------

const Image = ({ content, canManage }) => (
  <div>
    <div className={styles.wrapper}>
      <div
        className={
          !canManage && content.hasUserVisited
            ? styles.iconContainerVisited
            : styles.iconContainer
        }
      >
        <FontAwesomeIcon className={styles.icon} icon={['fas', 'image']} />
      </div>

      <div>
        <Title size="2XS" maxRows={2}>
          {content.title}
        </Title>
        <Paragraph maxRows={2}>{content.description}</Paragraph>
        <PreTitle className={styles.preTitle}>
          {content.label || 'Immagine'}
        </PreTitle>
      </div>
    </div>
  </div>
)

export default Image
